// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import moment from 'moment';
import * as echarts from 'echarts';

// Vue.use(router);
Vue.use(ElementUI);

Vue.use(require('vue-moment'));
Vue.prototype.moment = moment;
Vue.filter('dateYMDHMSFormat', function (dateStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dateStr).format(pattern);
});
Vue.filter('dateYMDFormat', function (dateStr, pattern = 'YYYY-MM-DD') {
  return moment(dateStr).format(pattern);
});

Vue.prototype.$echarts = echarts;

// ***************************** Begin of CORS *****************************
/*const cors = require('cors');
var app=express();

var corsOptions = {
  origin: 'http://localhost:8080',
  credentials: true,
  maxAge: '1728000'
  //这一项是为了跨域专门设置的
}
app.use(cors(corsOptions));*/
// ***************************** End of CORS *****************************

Vue.prototype.$alert = ElementUI.MessageBox.alert;
Vue.prototype.$confirm = ElementUI.MessageBox.confirm;

import {postRequest} from "./utils/api";
import {postKeyValueRequest} from "./utils/api";
import {putRequest} from "./utils/api";
import {deleteRequest} from "./utils/api";
import {getRequest} from "./utils/api";
import {initMenu} from "./utils/menus";
import 'font-awesome/css/font-awesome.min.css'

Vue.prototype.postRequest = postRequest;
Vue.prototype.postKeyValueRequest = postKeyValueRequest;
Vue.prototype.putRequest = putRequest;
Vue.prototype.deleteRequest = deleteRequest;
``
Vue.prototype.getRequest = getRequest;

Vue.config.productionTip = false;

/*
router.beforeEach((to, from, next) => {
  let needSetPassword = window.sessionStorage.getItem("needSetPassword");
  if (to.path !== '/'
    && to.path !== '/doLogin'
    && to.path !== '/loadAllTopMenusOfCurrentUser'
    && to.path !== '/logout'
    && to.path !== '/setPassword') {
    if (needSetPassword != null) {
      if (needSetPassword === "true") {
        if (window.sessionStorage.getItem("currentUser")) {
          initMenu(router, store);
          // router.replace({path: '/setPassword'});
        }
      } else {
        if (window.sessionStorage.getItem("currentUser")) {
          initMenu(router, store);
          // router.replace({path: '/setPassword'});
        }
        next();
      }
    } else {
      router.replace({path: '/'});
      // next('/');
    }
  } else {
    if (to.path == '/') {
      next();
    } else {
      if (window.sessionStorage.getItem("currentUser")) {
        initMenu(router, store);
        next();
      } else {
        next('/?redirect=' + to.path);
      }
    }
  }
});
*/

router.beforeEach((to, from, next) => {
  if (to.path === '/Login') {
    sessionStorage.removeItem('currentUser')
  }
  if (to.path == '/') {
    next();
  } else {
    if (window.sessionStorage.getItem("currentUser")) {
      initMenu(router, store);
      next();
    } else {
      next('/?redirect=' + to.path);
    }
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js